module.exports = __webpack_public_path__ + "static/media/angelo-pantazis.d184f362.jpg";